import { Mapper } from '../../../common/ddd/mapper.base';
import { SelfAppCategoryChartAllTimeAverageAggregateRoot } from '../../../core/domain/aggregates/app-category-metrics/self-app-category-chart-all-time-average.aggregate-root';
import { GetSelfAppCategoryChartAllTimeAverageResponseDto } from '../../../interface/dtos/app-category-metrics/get-self-app-category-chart-all-time-average.response.dto';

export type ISelfAppCategoryChartAllTimeAverageAggregateRootMapper = Mapper<
  SelfAppCategoryChartAllTimeAverageAggregateRoot,
  GetSelfAppCategoryChartAllTimeAverageResponseDto
>;

export class GetSelfAppCategoryChartAllTimeAverageAggregateRootMapper
  implements
    Omit<ISelfAppCategoryChartAllTimeAverageAggregateRootMapper, 'toDomain'>
{
  toResponse(
    entity: SelfAppCategoryChartAllTimeAverageAggregateRoot
  ): GetSelfAppCategoryChartAllTimeAverageResponseDto {
    return GetSelfAppCategoryChartAllTimeAverageAggregateRootMapper.toResponse(
      entity
    );
  }

  static toResponse(
    entity: SelfAppCategoryChartAllTimeAverageAggregateRoot
  ): GetSelfAppCategoryChartAllTimeAverageResponseDto {
    return {
      totalDurationAverage: Number(entity.totalAllTimeAverageDuration),
    };
  }
}
